import type { CompletedUserMatchProfile } from '../../features/matching-poc/lib/userMatchProfile';
import { DIMENSION_KEYS } from '../../features/matching-poc/types';
import { trackGaEvent } from './gtag';
import { GA4_EVENT_NAMES, type Ga4Species, type Ga4Surface } from './types';

export function trackQuizPageView(
  pagePath: string,
  shelterId?: string | null,
): void {
  trackGaEvent(GA4_EVENT_NAMES.quizPageView, {
    page_path: pagePath,
    shelter_id: shelterId?.trim() || undefined,
  });
}

export function trackQuizStart(
  species: Ga4Species,
  shelterId?: string | null,
): void {
  trackGaEvent(GA4_EVENT_NAMES.quizStart, {
    species,
    shelter_id: shelterId?.trim() || undefined,
  });
}

export function trackQuizComplete(
  species: Ga4Species,
  matchCount: number,
  shelterId?: string | null,
): void {
  trackGaEvent(GA4_EVENT_NAMES.quizComplete, {
    species,
    match_count: matchCount,
    shelter_id: shelterId?.trim() || undefined,
  });
}

export function trackQuizPreferencesFromProfile(
  species: Ga4Species,
  profile: CompletedUserMatchProfile,
  shelterId?: string | null,
): void {
  const shelter_id = shelterId?.trim() || undefined;

  for (const dimension_key of DIMENSION_KEYS) {
    const dim = profile[dimension_key];
    trackGaEvent(GA4_EVENT_NAMES.quizPreference, {
      species,
      dimension_key,
      detail_level: dim.detailLevel,
      importance: dim.importance,
      shelter_id,
    });
  }
}

export function trackMatchAnimalImpression(input: {
  species: Ga4Species;
  animalId: string;
  rank: number;
  matchPercent: number;
  surface: Ga4Surface;
  shelterId?: string | null;
}): void {
  trackGaEvent(GA4_EVENT_NAMES.matchAnimalImpression, {
    species: input.species,
    animal_id: input.animalId,
    rank: input.rank,
    match_percent: input.matchPercent,
    surface: input.surface,
    shelter_id: input.shelterId?.trim() || undefined,
  });
}

export function trackProfileLinkClick(input: {
  animalId: string;
  surface: Ga4Surface;
  shelterId?: string | null;
}): void {
  trackGaEvent(GA4_EVENT_NAMES.profileLinkClick, {
    animal_id: input.animalId,
    surface: input.surface,
    shelter_id: input.shelterId?.trim() || undefined,
  });
}

export function trackAdoptionApplicationClick(input: {
  surface: Ga4Surface;
  shelterId?: string | null;
}): void {
  trackGaEvent(GA4_EVENT_NAMES.adoptionApplicationClick, {
    surface: input.surface,
    shelter_id: input.shelterId?.trim() || undefined,
  });
}
